import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="mx-auto w-full max-w-2xl px-4 py-16 sm:px-6">
      <Card className="border-border bg-card" data-testid="payment-cancel-card">
        <CardContent className="flex flex-col items-center p-10 text-center">
          <XCircle className="h-10 w-10 text-muted-foreground" />
          <h1 className="mt-5 font-heading text-xl font-semibold">Paiement annulé</h1>
          <p className="mt-2 max-w-md text-sm text-muted-foreground">
            Votre paiement a été annulé et aucune somme n'a été débitée. Le créneau n'est pas
            réservé. Vous pouvez recommencer votre réservation ou choisir le paiement sur place.
          </p>
          <div className="mt-6 flex gap-3">
            <Button asChild data-testid="cancel-retry-button">
              <Link to="/reserver">Reprendre ma réservation</Link>
            </Button>
            <Button variant="outline" asChild>
              <Link to="/planning">Voir le planning</Link>
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
